/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as FaultActions from '../FaultActions'
import * as SecurityActions from '../../security/SecurityActions'
import * as Faults from '../../api/Faults'
import * as Airtime from '../../api/Airtime'
import {injectIntl, FormattedMessage} from 'react-intl';
import {Button, Grid, Divider, Notification, List, Select, Input, Accordion} from '@scuf/common';
import Loader from '../../common/Loader'
import {ACTION_TYPES, CORRECTIVE_ACTION_STATE} from "../common/FaultsConst";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import {verifyAirtimeException} from "../../utils/Helpers";
import {EXISTING_ACTION_ID, NEW_ACTION_ID} from "../common/FaultsUtils";
import DOMPurify from 'dompurify'


class ActionDetail extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            detail: {
                description: '',
                references: [],
                changingConfig: false,
                taskTips: [],
                failureModes: [],
            },
            testResults: [],
            activeAccordion: false,
            newTestResult: '',
            result: this.props.action.currentResult && this.props.action.type === ACTION_TYPES.TEST ? parseInt(this.props.action.currentResult, 10) : this.props.action.currentResult,
            apiPoint: userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Faults,
        }

        this.submitActionResult = this.submitActionResult.bind(this)
        this.timeout = 0;

    }

    componentDidMount() {
        this.setState({loading: true})
        let faultId = null;
        if (this.props.showCauses) {
            faultId = this.props.fault.faultId
        }
        // Represents option for adding/opening new test or adding existing test. No details should be fetched
        if (this.props.action.id === EXISTING_ACTION_ID || this.props.action.id === NEW_ACTION_ID
            || (this.props.action.existingTestId === 0 && this.props.action.learningLoopTable === true)) {
            this.setState({loading: false})
            return
        }
        this.props.FaultActions.fetchActionDetail(this.props.fault.assetId, this.props.action.existingTestId === 0 ?
            this.props.action.id : this.props.action.existingTestId, this.props.action.type,
            userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY), faultId).then(
            (response) => {
                this.setState({detail: response});
            }
        ).then(() => this.setState({loading: false})).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    getOriginalActionResult() {
        return this.props.action.currentResult && this.props.action.type === ACTION_TYPES.TEST ?
            parseInt(this.props.action.currentResult, 10) : this.props.action.currentResult
    }

    getTaskTips(taskTips) {
        return taskTips.map(t => <List.Content key={t.id}>{t.text}</List.Content>)
    }

    getStateOptions(test) {
        const {intl} = this.props
        let stateOptions = [{
            value: null,
            text: intl.formatMessage({id: 'fault.troubleshoot.test.result.not_performed'}),
            learningLoopTestResult: false,
        }];

        const testResults = test.id === EXISTING_ACTION_ID ? this.state.testResults : test.testResults;

        return stateOptions.concat(
            testResults.map(testR => {
                return {value: testR.id, text: testR.name, learningLoopTestResult: testR.learningLoopTestResult}
            }).sort((a, b) => a.value - b.value)
        )
    }

    /**
     * A test that has the attribute "learningLoopTable" set to true is a test that isn't originally assigned to the fault.
     * This can be an existing test or a new custom test. Existing tests have the attribute "existingTestId" set to non-zero.
     * Allocated Tests have attribute LearningLoopTable set to false.
     */
    getTestDetail(test, disabled, created, assetName) {
        // This test represents option for creating new tests or adding existing test to current fault.
        if (test.id === EXISTING_ACTION_ID || test.id === NEW_ACTION_ID) {
            return this.renderRowForAddingTest(test, disabled, created, assetName)
        }

        return (
            <React.Fragment>
                <h5><FormattedMessage id="fault.troubleshoot.action.detail.test" /></h5>
                <Grid>
                    {this.getTestDescription(test, created, assetName)}
                    {/*{this.getResultButtonGroupWithAccordion(test, disabled, false)}*/}
                    {/* If there are no custom test results and current result is set to null, user is able to delete
                    this test. Only for test that are newly assigned or custom. */}
                    {test.learningLoopTable === true ?
                        <Grid.Row>
                            <Grid.Column width={2} className="remove-test-column">
                                <Button
                                    className="full-input"
                                    content="Remove Test"
                                    type={"primary"}
                                    onClick={() => {
                                        this.state.apiPoint.deleteTest(this.props.fault.assetId, this.props.fault.faultId, test.id).then(() => {
                                            this.props.fetchNewData()
                                            this.props.fetchNewOptions(ACTION_TYPES.TEST)
                                        })
                                    }}
                                    disabled={test.currentResult !== null ||
                                        test.testResults.filter(testResult => testResult.learningLoopTestResult).length !== 0}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        :
                        null
                    }
                </Grid>
            </React.Fragment>
        )
    }

    getListLinkItems(list) {
        if (list.length === 0) {
            return <span><FormattedMessage id="fault.troubleshoot.action.detail.noreferences"/></span>
        }
        return <ul>{list.map(s => <li key={s.link.techPubId}> {
            s.available ? <Button type="link" content={s.title.length > 0 ? s.title :
                    (<FormattedMessage id="fault.troubleshoot.action.detail.refs.titleUndefined"/>)}
                                  onClick={() => this.openReference(s)}/> :
                <span>{s.title.length > 0 ? s.title : (<FormattedMessage id="fault.troubleshoot.action.detail.refs.titleUndefined"/>)} ({s.name})</span>}
        </li>)}</ul>
    }

    openReference(ref) {
        this.state.apiPoint.fetchTechPubDocument(this.props.fault.assetId, ref.link.techPubId).then(
            (response) => {
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                response.blob().then(b => {
                    const fileURL = URL.createObjectURL(b)
                    a.href = fileURL
                    a.download = ref.name
                    a.target = "_blank"
                    a.click()
                    URL.revokeObjectURL(fileURL)
                    a.remove()
                })
            }
        ).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    setResult(buttonData, oldValue) {
        if (buttonData.value !== oldValue) {
            this.setState({result: buttonData.value})
            this.submitActionResult(buttonData);
        }
    }

    delayProcessingOnClick() {
        clearTimeout(this.timeout)
    }

    submitActionResult(buttonData) {
        const me = this;
        clearTimeout(this.timeout)
        // do not store value that is already set (this prevents from throwing business exception and logging out)
        if (buttonData.value !== this.getOriginalActionResult()) {
            this.timeout = setTimeout(function () {
                    me.props.onResultSelected(me.props.action, buttonData);
                }, 1500
            )
        }
    }

    /**
     * Renders row for adding existing tests or creating new custom tests
     */
    renderRowForAddingTest(test, disabled, created, assetName) {
        const {intl} = this.props

        // Option to create new Test render only input for new test name and button for creating test
        if (test.id === NEW_ACTION_ID) {
            return (
                <Grid.Row className="align-row">
                    <Grid.Column width={10}>
                        <Input
                            className="full-input"
                            label={intl.formatMessage({id: `fault.troubleshoot.action.test`})}
                            onChange={(value) => this.props.setNotExistingName(value)}
                        />
                    </Grid.Column>
                    <Grid.Column width={2}>
                        <Button
                            className="full-input"
                            type={"primary"}
                            content={intl.formatMessage({id: `fault.troubleshoot.action.test.button`})}
                            onClick={() => this.state.apiPoint.createNewTest(this.props.fault.assetId, this.props.fault.faultId, this.props.notExistingComment).then(
                                () => {
                                    this.props.setNotExistingName("")
                                    this.props.fetchNewData()
                                })}
                            disabled={this.props.notExistingComment === ""}
                        />
                    </Grid.Column>
                </Grid.Row>
            )
        }

        return (
            <React.Fragment>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Select
                                placeholder={intl.formatMessage({id: `fault.troubleshoot.action.detail.select.test.placeholder`})}
                                options={this.props.options ? this.props.options : []}
                                label={intl.formatMessage({id: `fault.troubleshoot.action.detail.select.test.label`})}
                                onChange={(value) => {
                                    this.state.apiPoint.fetchTestResultsForTest(this.props.fault.assetId, this.props.fault.faultId, this.props.options[value].id).then(r => {
                                        this.setState({testResults: r})
                                        this.props.onSelectorChange(value)
                                        if (value !== this.props.options.length - 1) {
                                            this.props.FaultActions.fetchActionDetail(this.props.fault.assetId, this.props.options[value].id, this.props.action.type,
                                                userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY), this.props.fault.faultId).then(
                                                (response) => {
                                                    this.setState({detail: response});
                                                }
                                            )
                                        } else {
                                            this.setState({detail: {
                                                    description: '',
                                                    references: [],
                                                    changingConfig: false,
                                                    taskTips: [],
                                                    failureModes: [],
                                                }})
                                        }
                                    })
                                }}
                                value={this.props.selectedOption}
                                disabled={false}
                                fluid
                                search={true}
                                helperText={intl.formatMessage({id: `fault.troubleshoot.action.detail.select.test.helperText`})}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    {/* Renders description and result buttons for existing tests. */}
                    {this.getTestDescription(test, created, assetName)}
                    {/*{this.getResultButtonGroupWithAccordion(test, disabled, false)}*/}
                </Grid>
            </React.Fragment>
        )
    }

    getTestDescription(test, created, assetName) {
        // If test is the custom test then we can't render any details from the database.
        if (test.learningLoopTable === true && test.existingTestId === 0) {
            return null
        }

        const descriptionDisabled =
            this.state.detail.description === "" ||
            this.state.detail.description == null ||
            this.state.detail.description === ''
                ?
                'description-disabled'
                : '' +
                'description';
        const referenceDisabled = this.state.detail.references.length <= 0 ? 'references-disabled' : 'references';
        const taskTipDisabled = this.state.detail.taskTips.length <= 0 ? 'taskTips-disabled' : 'taskTips';

        // Fault creation date need to be converted to YYYY_mm_dd_HH_MM_SS.FFF000
        // Additional 3 zeros at the end are added because of python script
        // which is rounding on 6 places for milliseconds
        let createdFormatted = created.replaceAll(" ", "_")
        createdFormatted = createdFormatted.replaceAll("-", "_")
        createdFormatted = createdFormatted.replaceAll(":", "_")
        createdFormatted = createdFormatted.replaceAll("T", "_")
        createdFormatted = createdFormatted.replaceAll(".", "_")
        createdFormatted = createdFormatted + "000"

        let description
        if (this.state.detail.description != null) {
            description = this.state.detail.description.replaceAll("##timestamp##", createdFormatted)
            description = description.replaceAll("##assetName##", assetName)
        } else {
            description = null
        }

        return (
            <Grid.Row>
                <Grid.Column width={8} sWidth={12}>
                    <div className={descriptionDisabled}>
                        <h5><FormattedMessage id="fault.troubleshoot.action.detail.desc"/></h5>
                        {description === "" ?
                            <FormattedMessage id="fault.troubleshoot.action.detail.desc.notAvailable"/>
                            :
                            <div className="description-div" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(description)}}/>
                        }
                    </div>
                </Grid.Column>
                <Grid.Column width={4} sWidth={12}>
                    <div className={referenceDisabled}>
                        <h5><FormattedMessage id="fault.troubleshoot.action.detail.refs"/></h5>
                        {this.getListLinkItems(this.state.detail.references)}
                    </div>
                </Grid.Column>
                <Grid.Column width={8} sWidth={12}>
                    <div className={taskTipDisabled}>
                        <h5><FormattedMessage id="fault.troubleshoot.action.detail.tasktips"/></h5>
                        {this.state.detail.taskTips.length <= 0 ?
                            <FormattedMessage id="fault.troubleshoot.action.detail.tasktips.noAvailable"/>
                            :
                            <List divided={true}>
                                {this.getTaskTips(this.state.detail.taskTips)}
                            </List>
                        }
                    </div>
                </Grid.Column>
            </Grid.Row>
        )
    }

    getResultButtonGroup(resultButtonData, disabled) {
        return (
            <Button.Group className="button-group">
                {
                    resultButtonData.map((buttonData, index) => {
                        return (
                            <Button
                                className="result-button"
                                key={index} content={buttonData.text}
                                disabled={disabled}
                                type={buttonData.value === this.state.result ? 'inline' : 'inline-secondary'}
                                onClick={() => this.toggleResultButton(buttonData)}/>
                        )
                    })
                }
            </Button.Group>
        )
    }

    getResultButtonGroupWithAccordion(test, disabled, showAccordion) {
        const {intl} = this.props
        const stateOptions = this.getStateOptions(test)

        return (
            <Grid.Row>
                <Grid.Column width={12}>
                    {showAccordion ?
                        <Accordion className="add-custom-result">
                            <Accordion.Content title={"Add New Test Result"} active={this.state.activeAccordion} onClick={() => this.setState({activeAccordion: !this.state.activeAccordion})}>
                                <Grid.Row className="align-row">
                                    <Grid.Column width={8}>
                                        <Input
                                            className="full-input"
                                            value={this.state.newTestResult}
                                            label={intl.formatMessage({id: `fault.troubleshoot.action.testResult`})}
                                            onChange={(value) => this.setState({newTestResult: value})}
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={2}>
                                        <Button
                                            className="full-input"
                                            type={"primary"}
                                            content={intl.formatMessage({id: `fault.troubleshoot.action.testResult.button`})}
                                            onClick={() => {
                                                this.state.apiPoint.createNewTestResult(this.props.fault.assetId, test.id, this.state.newTestResult, test.learningLoopTable).then(
                                                    () => {
                                                        this.props.fetchNewData()
                                                        this.setState({newTestResult: ""})
                                                    })
                                            }}
                                            disabled={this.state.newTestResult === ""}
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={2}>
                                        <Button
                                            className="full-input"
                                            content="Remove Last"
                                            type={"primary"}
                                            onClick={() => {
                                                this.state.apiPoint.deleteTestResult(this.props.fault.assetId, this.props.fault.faultId, stateOptions[stateOptions.length - 1].value, test.id).then(() => {
                                                    this.props.fetchNewData()
                                                })
                                            }}
                                            disabled={stateOptions.filter(testResult => testResult.learningLoopTestResult).length === 0 ||
                                                stateOptions[stateOptions.length - 1].value === parseInt(test.currentResult, 10)}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Accordion.Content>
                        </Accordion>
                        :
                        null
                    }
                    <div className="test-buttonGroup">
                        <h5 className="result-header"><FormattedMessage
                            id="fault.troubleshoot.action.detail.select.test.label"/></h5>
                        {this.getResultButtonGroup(stateOptions, disabled)}
                    </div>
                </Grid.Column>
            </Grid.Row>
        )
    }

    toggleResultButton(buttonData) {
        this.delayProcessingOnClick(buttonData.value)
        this.setResult(buttonData, this.state.result)
    }

    renderRowForAddingCorrectiveActions(action) {
        const {intl} = this.props

        const isExistingActionRow = action.id === EXISTING_ACTION_ID;

        let correctiveActionInput =
            <Grid.Row>
                <Grid.Column width={9} sWidth={12}>
                    <Input
                        className="full-input"
                        label={intl.formatMessage({id: `fault.troubleshoot.action.ca`})}
                        onChange={(value) => this.props.setNotExistingName(value)}
                    />
                </Grid.Column>
            </Grid.Row>
        if (isExistingActionRow) {
            correctiveActionInput =
                <Grid.Row>
                    <Grid.Column width={9} sWidth={12}>
                        <Select
                            placeholder={intl.formatMessage({id: "fault.troubleshoot.action.detail.select.ca.placeholder"})}
                            options={this.props.options}
                            label={intl.formatMessage({id: "fault.troubleshoot.action.detail.select.ca.label"})}
                            onChange={(value) => {
                                this.props.onSelectorChange(value);
                            }}
                            value={this.props.selectedOption}
                            disabled={false}
                            fluid
                            search={true}
                            helperText={intl.formatMessage({id: "fault.troubleshoot.action.detail.select.ca.helperText"})}
                        />
                    </Grid.Column>
                </Grid.Row>
        }

        return (
            <React.Fragment>
                <h5><FormattedMessage id="fault.troubleshoot.action.detail.ca"/></h5>
                <Grid className="align-row">
                    {correctiveActionInput}
                    <Divider fitted/>
                    <Grid.Row>
                        <Grid.Column width={3} className={isExistingActionRow ? "align-self" : ""}>
                            <Button
                                className="mobile-max-width-button"
                                type={"primary"}
                                content={intl.formatMessage({id: "fault.troubleshoot.action.ca.button"})}
                                onClick={() => this.props.onButtonClick(action)}
                                disabled={isExistingActionRow
                                    ? this.props.selectedOption == null : this.props.notExistingComment === ''}
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </React.Fragment>
        )
    }

    getCorrectiveActionDetail(action, disabled) {
        const {intl} = this.props

        if (action.id === NEW_ACTION_ID || action.id === EXISTING_ACTION_ID) {
            return this.renderRowForAddingCorrectiveActions(action)
        }

        const stateOptions = [];
        for (const key in CORRECTIVE_ACTION_STATE) {
            if (CORRECTIVE_ACTION_STATE.hasOwnProperty(key)) {
                stateOptions.push({
                    value: CORRECTIVE_ACTION_STATE[key],
                    text: intl.formatMessage({id: 'fault.troubleshoot.ca.state.' + CORRECTIVE_ACTION_STATE[key]}),
                });
            }
        }

        stateOptions.sort(orderOptions);
        let notification = null
        if (this.state.detail.changingConfig) {
            notification =
                <Grid.Row>
                    <Grid.Column width={8} sWidth={12}>
                        <div>
                            <Notification
                                hasIcon={true}
                                severity={"information"}
                            >
                                {<FormattedMessage id="troubleshooting.correctiveAction.symptom"/>}
                            </Notification>
                        </div>
                    </Grid.Column>
                </Grid.Row>
        }
        const descriptionDisabled =
            this.state.detail.description === "" ||
            this.state.detail.description == null ||
            this.state.detail.description === ''
                ?
                'description-disabled'
                :
                'description';
        const referenceDisabled = this.state.detail.references.length <= 0 ? 'references-disabled' : 'references';
        const validateDisabled = 'validate-disabled';
        const taskTipDisabled = this.state.detail.taskTips.length <= 0 ? 'taskTips-disabled' : 'taskTips';
        const causesDisable = this.state.detail.failureModes.length <= 0 ? 'causes-disabled' : 'causes';
        return (
            <React.Fragment>
                <h5><FormattedMessage id="fault.troubleshoot.action.detail.ca"/></h5>
                <Grid>
                    {notification}
                    <Grid.Row>
                        <Grid.Column width={8} sWidth={12}>
                            <div className={descriptionDisabled}>
                                <h5><FormattedMessage id="fault.troubleshoot.action.detail.desc"/></h5>
                                {this.state.detail.description === '' || this.state.detail.description == null ?
                                    <FormattedMessage id="fault.troubleshoot.action.detail.desc.notAvailable"/>
                                    :
                                    <div className="description-div"
                                         dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.state.detail.description)}}/>
                                }
                            </div>
                        </Grid.Column>
                        <Grid.Column width={4} sWidth={12}>
                            <div className={referenceDisabled}>
                                <h5><FormattedMessage id="fault.troubleshoot.action.detail.refs"/></h5>
                                {this.getListLinkItems(this.state.detail.references)}
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Divider fitted/>
                    {
                        this.props.showCauses ?
                            <Grid.Row>
                                <Grid.Column width={8} sWidth={12}>
                                    <div className={causesDisable}>
                                        <h5><FormattedMessage id="fault.troubleshoot.action.detail.causes"/></h5>
                                        <div>{this.state.detail.failureModes.map((item, id) =>
                                            <p key={id}>{item.name}</p>)}</div>
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            :
                            ''
                    }
                    <Divider fitted/>
                    <Grid.Row>
                        <Grid.Column width={8} sWidth={12}>
                            <div className={validateDisabled}>
                                <h5><FormattedMessage id="fault.troubleshoot.action.detail.validate"/></h5>
                                <FormattedMessage id="fault.troubleshoot.action.detail.validate.notAvailable"/>
                            </div>
                        </Grid.Column>
                        <Grid.Column width={8} sWidth={12}>
                            <div className={taskTipDisabled}>
                                <h5><FormattedMessage id="fault.troubleshoot.action.detail.tasktips"/></h5>
                                {this.state.detail.taskTips.length <= 0 ?
                                    <FormattedMessage id="fault.troubleshoot.action.detail.tasktips.noAvailable"/>
                                    :
                                    <List divided={true}>
                                        {this.getTaskTips(this.state.detail.taskTips)}
                                    </List>
                                }
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </React.Fragment>
        )
    }

    render() {
        const {action, disabled, fault} = this.props
        let dis = disabled
        if (dis == null) {
            dis = false
        }
        let component

        if (action.type === ACTION_TYPES.TEST) {
            component = this.getTestDetail(action, dis, fault.details.created, fault.details.asset.name)
        } else {
            component = this.getCorrectiveActionDetail(action, dis)
        }
        return (
            <div className="action-detail">
                {component}
                <Loader loading={this.state.loading}/>
            </div>
        )
    }
}

const orderOptions = (a, b) => {
    if (a.text > b.text) {
        return -1
    }
    if (a.text < b.text) {
        return 1
    }
    return 0;
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}


export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ActionDetail)))